import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearch } from '../api/queries.js';
import ClusterCard from '../components/ClusterCard.js';

export default function Search() {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  const [query, setQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const results = useSearch(query);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  // debounce typing → query
  useEffect(() => {
    const timer = setTimeout(() => setQuery(input.trim()), 300);
    return () => clearTimeout(timer);
  }, [input]);

  const items = results.data?.items ?? [];

  return (
    <div className="space-y-3 px-4 pb-4 pt-20">
      <h1 className="text-2xl font-bold">{t('search.title')}</h1>
      <input
        ref={inputRef}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder={t('search.placeholder')}
        className="w-full rounded-xl border border-neutral-300 bg-white px-4 py-3 dark:border-neutral-700 dark:bg-neutral-900"
      />
      {results.isLoading && query && (
        <p className="py-8 text-center text-neutral-500">{t('common.loading')}</p>
      )}
      {items.map((item) => (
        <ClusterCard key={item.id} item={item} />
      ))}
      {results.isSuccess && query && items.length === 0 && (
        <p className="py-8 text-center text-neutral-400">{t('search.noResults')}</p>
      )}
    </div>
  );
}
